import React, { useState, useEffect} from 'react';
import { ProjectBeneficiariesPresenter } from '@presenters/screens/project-beneficiaries-presenter';
import { IProjectBeneficiaries } from "@interfaces/screens/beneficiaries.interface";
import { DataGrid, Column, MasterDetail, Summary, TotalItem, CustomRule, Scrolling } from 'devextreme-react/data-grid';
import { Utilities, Enums, Constants, numeral } from "@utils";
import ProjectDetail from './project-detail';
import styles from './project-beneficiaries.module.scss';
import { Button } from "reactstrap";
import { ProaSummaryPresenter } from '@presenters/screens/proa-summary.presenter';

export interface IProjectBeneficiariesProps {
  basicData: any;
  subProyect: any;
  duplicatesSP: any;
  summaryPresenter: ProaSummaryPresenter;
}

const ProjectBeneficiaries: React.FC<IProjectBeneficiariesProps> = (props: IProjectBeneficiariesProps) => {
  const [basicData, setBasicData] = useState([])
  const [duplicatesSP, setDuplicatesSP] = useState([])
  const [dataSource, setDataSource] = useState([])
  const [columns, setColumns] = useState([])
  const [summaryConfig, setSummaryConfig] = useState([])
  const [years, setYears] = useState(null)

  let view: IProjectBeneficiaries = {
    state: {
      basicData: basicData,
      setBasicData: setBasicData,
      dataSource: dataSource,
      setDataSource: setDataSource,
      columns: columns,
      setColumns: setColumns,
      years: years,
      setYears: setYears,
      duplicatesSP: duplicatesSP,
      setDuplicatesSP: setDuplicatesSP,
      summaryConfig: summaryConfig,
      setSummaryConfig: setSummaryConfig,
    }
  };

  let presenter =  new ProjectBeneficiariesPresenter(view);

  useEffect(() => {
    if(props.basicData && props.subProyect && presenter.formMasters && props.duplicatesSP){
      presenter.getData(props.basicData, props.subProyect, props.duplicatesSP)
    } 
    //eslint-disable-next-line
  }, [props.duplicatesSP]);
  
  const renderCellTemplate = (
    container: any,
    options: any,
    column: any
  ) => {
    if (!Utilities.isNullObject(column.onValueChanged)) {
      column.onValueChanged(options);
    }
    let _value = options.value;
    const _format = column.format;
    switch (column.fieldType) {
      case Enums.FieldTypes.Number:
        {
          _value = `${numeral(options.value).format(
            _format ? _format : Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL
          )}`;
        }
        break;
    }
    container.textContent = _value;
  };

  const renderColumn = (column: any, pivot?: any, dataDetail?: any) => { 
    const commonProps = {
      cellTemplate: (container: any, _props: any) =>
        renderCellTemplate(container, _props, column),
      dataField: column.dataField,
      caption: column.caption,
      width: column.width,
      allowEditing: !column.readOnly,
      alignment: column.alignment,
      calculateCellValue: column.calculateCellValue,
      visible: column.visible,
      groupIndex: column.groupIndex,
      sortOrder: column.sortOrder,
      fixed: column.fixed,
      fixedPosition: column.fixedPosition,
    };
    switch (column.fieldType) {
      default: {
        return (
          <Column
            {...commonProps}
            key={`project-${column.dataField}`}
            dataType={column.dataType}
          >
          {getDuplicateCalculation(column, pivot, dataDetail)}
          </Column>
        );
      }
    }
  };

  const renderDetail = (propsDetail:any) => {
    return (
      <ProjectDetail
        summaryPresenter={props.summaryPresenter}
        presenter={presenter}
        renderColumn={renderColumn}
        data={propsDetail.data}
      ></ProjectDetail>
    );
  }

  const calculateTotalRow = (options: any) => {
    if (options.summaryProcess === 'start' && options.name !== "notValue") {
      options.totalValue = 0;
    } else if (options.summaryProcess === 'calculate' && options.name !== "notValue") {
      let sumaData = 0;
      let sumaDup = 0;

      let anio = options.name.substr(-4)

      if(!isNaN(anio) && (options.name.includes("Womens") || options.name.includes("Mens")) && !options.name.includes("Duplicate")){
        let columnName = options.name.includes("Mens") ? "PFFRRTotalHombres" : "PFRRTotalMujeres";
        duplicatesSP.forEach(dup => { if(dup.PPresuAnio == anio) sumaDup += (dup[columnName] || 0) });
      }
      
      let newName = options.name.replace("Duplicate","")
      dataSource.forEach(data => { sumaData += (data[newName] || 0) });
       
      options.totalValue = sumaData - sumaDup;
    }
  }
  
  const getDuplicateCalculation = (column: any, pivot: any, dataDetail: any) => {
    return column.validateDuplicates ? (
      <CustomRule ignoreEmptyValue={true} validationCallback={(e: any) => presenter.validateCell(e, pivot, dataDetail)} message={column.validationErrorMessage}/>
    ) : (
      ''
    );
  };
  
  return (
    <>
      { dataSource.length 
        ?
          <>
            <h1 className={styles.SuperposicionTitle}>
              {presenter.currentLabels.get("SuperposicionTitle")}
            </h1>  
            <DataGrid id="grid-container"
              dataSource={dataSource}
              keyExpr="ID"
              showBorders={true}
              {...presenter.getGridProps()}
            >
              {summaryConfig ? 
                <Summary calculateCustomSummary={calculateTotalRow}>
                  {summaryConfig.map((sumConfig: any, index: number) => {
                    return <TotalItem key={index} {...sumConfig} />;
                  })}
                </Summary>
                : null}
              {columns.map(col=>renderColumn(col))}
              <Scrolling mode="infinite" />
              <MasterDetail
                enabled={true}
                render={renderDetail}
              />
            </DataGrid> 
          </>
        : null
      }
    </>
  );
  
}

export default ProjectBeneficiaries;